"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cccisdHiddenBlock = _interopRequireDefault(require("cccisd-hidden-block"));
var _style = _interopRequireDefault(require("./style.css"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdLaravelAssignment = require("cccisd-laravel-assignment");
var _cccisdWysiwyg = _interopRequireDefault(require("cccisd-wysiwyg"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdTabs = _interopRequireDefault(require("cccisd-tabs"));
var _index = require("../index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Boilerplate = window.cccisd.boilerplate;

/**
 * For an app to properly know which role "activationEmail" values to use when sending an email,
 * make sure that this "role" key/val pair is added:
 *
 * Example:
 * in storage/app/appdefs/definitions/routes/uberadmin/manage/tables/orgAdmin_tables.json
 * ...
 * {
	"handle": "lastLogin",
	"label": "Last Login",
	"name": "user.lastLoginDate",
	"filter": true,
	"sort": true,
	"renderAs": {
		"type": "LastLogin",
		"class": "html",
		"settings": {
			"role": "orgAdmin"		<---- this one
		}
	},
	"filterSettings": { "type": "date" }
* }
* ...
* */
var ActivationEmailForm = function ActivationEmailForm(props) {
  var siteContent = props.fields.siteContent;
  var activationEmail = siteContent.activationEmail;
  var initialValues = props.initialValues;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    tabList = _useState2[0],
    setTabList = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    counter = _useState4[0],
    setCounter = _useState4[1];
  (0, _react.useEffect)(function () {
    // role default values for email get turned into empty strings so that they use the main default values to start
    var roleDefaults = {};
    Object.keys(initialValues).forEach(function (k) {
      roleDefaults[k] = '';
    });
    var allRolesDefaultValues = _index.rolesList.reduce(function (res, role) {
      res[role.handle] = {
        activationEmail: _objectSpread({}, roleDefaults)
      };
      return res;
    }, {});
    if (!('siteContent' in props.settings)) {
      props.updateSettings(_objectSpread(_objectSpread({}, props.settings), {}, {
        siteContent: _objectSpread({
          activationEmail: _objectSpread({}, initialValues)
        }, allRolesDefaultValues)
      }));
    }

    // add content to the tabs component
    var tabs = [{
      name: 'default',
      title: 'Default',
      content: form(activationEmail)
    }];
    _index.rolesList.forEach(function (role) {
      var label = role.label;
      var handle = role.handle;
      var defaultSubject = activationEmail.subject.value;
      var defaultBody = activationEmail.body.value;
      var subjectValue = siteContent[handle].activationEmail.subject.value;
      var bodyValue = siteContent[handle].activationEmail.body.value;
      var hasCustomSubjectValue = subjectValue && subjectValue !== defaultSubject;
      var hasCustomBodyValue = bodyValue && bodyValue !== defaultBody;
      var hasCustomValue = hasCustomSubjectValue || hasCustomBodyValue;
      tabs.push({
        name: handle,
        title: hasCustomValue ? /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("span", {
          style: {
            color: 'red'
          }
        }, "* "), " ", label) : label,
        content: form(siteContent[handle].activationEmail, handle, label, hasCustomValue)
      });
    });
    setTabList(tabs);
  }, [props.settings]);
  var form = function form(formProps, roleHandle, roleLabel, hasCustomValue) {
    var bodyContent = formProps.body.value || siteContent.activationEmail.body.value;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].subject_body
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'right',
        gap: '25px'
      }
    }, roleHandle && hasCustomValue && /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-xs btn-link",
      onClick: function onClick(e) {
        formProps.body.onChange('');
        formProps.subject.onChange('');
        setCounter(function (prev) {
          return prev + 1;
        });
      }
    }, /*#__PURE__*/_react["default"].createElement("span", null, "Reset ", roleLabel)), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      title: "Preview Email",
      size: "large",
      trigger: /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].right_flex_content
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-primary"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Preview Email"))),
      render: function render() {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].indented
        }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelAssignment.MessageViewer, {
          deployment: {
            hash: ''
          },
          messageObject: {
            category: 'PREVIEW',
            messageMethod: 'EMAIL',
            settings: {
              recipientsType: 'Preview',
              label: 'Preview'
            },
            condition: 'TEMPLATE',
            messageInfo: {
              subject: formProps.subject.value || siteContent.activationEmail.subject.value,
              body: bodyContent,
              actionUrl: Boilerplate.url('/account/activate/_pawnHash_'),
              actionText: 'Activate Account'
            }
          }
        }));
      }
    })), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
      label: "Subject:",
      field: formProps.subject,
      placeholder: siteContent.activationEmail.subject.value
    }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
      field: formProps.body,
      label: "Body:",
      key: roleHandle
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
      content: formProps.body.value || siteContent.activationEmail.body.value,
      type: "textarea",
      onChange: function onChange(val) {
        return formProps.body.onChange(val);
      },
      settings: {
        toolbar: ['bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | forecolor backcolor | hr charmap', 'formatselect styleselect | link unlink | table | code ']
      },
      key: counter
    }))));
  };
  return /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
    title: "Activation Emails"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      margin: '15px',
      width: 'fit-content',
      padding: '15px',
      background: 'aliceblue',
      borderBottom: '2px solid lightblue'
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: 'red'
    }
  }, "*"), " : contains custom content"), /*#__PURE__*/_react["default"].createElement(_cccisdTabs["default"], {
    tabList: tabList,
    orientation: "vertical",
    verticalTabWidths: {
      left: 2,
      right: 10
    }
  }));
};
var _default = exports["default"] = ActivationEmailForm;